import * as React from "react";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Navbar/Mainnav.jsx";
import Footer from "./components/Footer/Footer.jsx";
import Contact from "./Pages/Contact";
import Home from "./Pages/Home";
import Plans from "./Pages/Plans.jsx";
import Abt from "./Pages/Abt.jsx";
import Test from "./Pages/Test.jsx";
import AOS from "aos";
import "aos/dist/aos.css";

import "./App.css";
import { ThreeCircles } from "react-loader-spinner";
import Careerpg from "./Pages/Careerpg.jsx";
// import SignUp from "./Pages/SignUp.jsx";

function App() {
  useEffect(() => {
    AOS.init();
  }, []);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {loading ? (
        <div className="placeLoader">
          <ThreeCircles
            backgroundColor="black"
            color="black"
            height="100"
            width="100"
            // color="white"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel="three-circles-rotating"
            outerCircleColor=""
            innerCircleColor=""
            middleCircleColor=""
          />
        </div>
      ) : (
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <Header />
                  <Home />
                  <Footer color="#94D25C" />
                </>
              }
            ></Route>
            <Route
              path="/about"
              element={
                <>
                  <Header />
                  <Abt /> <Footer color="#2563EB" />
                </>
              }
            ></Route>
            <Route
              path="/contact"
              element={
                <>
                  <Header />
                  <Contact />
                  <Footer color="#94D25C" />
                </>
              }
            ></Route>
            <Route
              path="/plans"
              element={
                <>
                  <Header />
                  <Plans />
                  <Footer />
                </>
              }
            ></Route>
            <Route
              path="/tests"
              element={
                <>
                  <Header />
                  <Test />
                  <Footer />
                </>
              }
            ></Route>
            <Route
              path="/career"
              element={
                <>
                  <Header />
                  <Careerpg/>
                  <Footer />
                </>
              }
            ></Route>
            {/* <Route
              path="/signup"
              element={
                <>
                  <SignUp />
                </>
              }
            ></Route> */}
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
}

export default App;
